import React, { useEffect, useState } from 'react';
import { TabsOrentations } from './MTabs.model';

import MTabsView from './MTabs.view';

type Props<Tabs extends string> = {
  activeTab: Tabs;
  className?: string;
  classNameItemSelected?: string;
  classNameItem?: string;
  orientation?: TabsOrentations;
  onTabClick?: (tab: Tabs) => void;
  onBlockedClick?: (tab: Tabs, click: () => void) => void;
};

const MTabs = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  const [activeTabState, setActiveTabState] = useState<Tabs>(props.activeTab);

  useEffect(() => {
    setActiveTabState(() => props.activeTab);
  }, [props.activeTab, setActiveTabState]);

  return (
    <MTabsView
      className={props.className}
      activeTab={activeTabState}
      orientation={props.orientation}
      classNameItem={props.classNameItem}
      classNameItemSelected={props.classNameItemSelected}
      onTabClick={(tab: Tabs) => {
        if (props.onBlockedClick) {
          props.onBlockedClick(tab, () => {
            setActiveTabState(() => tab);
          });

          return;
        }

        setActiveTabState(() => tab);
        props.onTabClick?.(tab);
      }}
    >
      {props.children}
    </MTabsView>
  );
};

MTabs.displayName = 'MTabs';
MTabs.defaultProps = {
  orientation: TabsOrentations.Horizontal,
};

export default MTabs;
